import { createAction, props } from '@ngrx/store';
import { User } from '@gwo/textbook-api-client/lib/interface/user.model';

export const updateUser = createAction('[User] Update User');
export const updateUserAndRedirectToShelf = createAction(
  '[User] Update User And Redirect To Shelf'
);
export const setUserData = createAction('[User] Set User Data', props<{ user: User }>());
